import styles from './Navbar.module.css';
import { useState } from 'react';
import Hamburger from './shared/icon-hamburger.svg';
import Close from './shared/icon-close.svg';
import Logo from './shared/logo.svg';
import { Link } from 'react-router-dom';

const Navbar = () => {
    const [showMenu, setShowMenu] = useState(false);

    const toggleMenu = () => {
        setShowMenu(prevShowMenu => !prevShowMenu);
    };

    return (
        <nav className={styles.NavCon}>
            <img src={Logo} alt="Logo" className={styles.logo} />
            <hr className={styles.navHr} />
            <div className={`${styles.navLinks} ${showMenu ? styles.active : ''}`}>
                <Link to='/'>00 Home</Link>
                <Link to='/destination'>01 Destination</Link>
                <Link to='/crew'>02 Crew</Link>
                <Link to='/technology'>03 Technology</Link>
            </div>
            <div className={styles.menuBar}>
                <img src={showMenu ? Close : Hamburger} alt="menu" onClick={toggleMenu} />
            </div>
        </nav>
    );
};

export default Navbar;